var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6458 7.4375H9.5625V0.354167C9.5625 0.15849 9.40401 0 9.20833 0H7.79167C7.59599 0 7.4375 0.15849 7.4375 0.354167V7.4375H0.354167C0.15849 7.4375 0 7.59599 0 7.79167V9.20833C0 9.40401 0.15849 9.5625 0.354167 9.5625H7.4375V16.6458C7.4375 16.8415 7.59599 17 7.79167 17H9.20833C9.40401 17 9.5625 16.8415 9.5625 16.6458V9.5625H16.6458C16.8415 9.5625 17 9.40401 17 9.20833V7.79167C17 7.59599 16.8415 7.4375 16.6458 7.4375Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrement);
export default __webpack_public_path__ + "static/media/increment.d1dfc0d8c65997b1ba0fcb2afa365723.svg";
export { ForwardRef as ReactComponent };